export const getAttendacePercentage = (present: number, total: number) => {
  if (!present || !total) {
    return 0;
  }
  if (present === 0 || total === 0) {
    return 0;
  }
  return Number(((present / total) * 100).toFixed(0));
};

export const currencyFormatter = (value: number) => {
  const locale = 'en-IN';
  // const options = {
  //   style: "currency",
  //   currency: "INR"
  // }

  const formatter = new Intl.NumberFormat(locale);
  return formatter.format(value);
};

export const capitalizeFirstLetter = (string: string) => string.charAt(0).toUpperCase() + string.slice(1);

export function increasedPrecentage(value1: number, value2: number) {
  if (value1 === 0) {
    return value2;
  }
  if (value2 === 0) {
    return value1;
  }
  return ((Math.abs(value1 - value2) / value1) * 100).toFixed(2);
}
